import { initPipelinesIndex } from '~/pipelines/pipelines_index';

initPipelinesIndex();
